import { Controller } from "@hotwired/stimulus"

// The evidence pane loads into a turbo frame, so the queue list beside it is
// never re-rendered when the selection moves - not by clicking a row, and not
// by the pane's own Prev/Next. Keep the highlight in step with whatever the
// frame is actually showing.
export default class extends Controller {
  static targets = ["row"]

  connect() {
    this.syncHighlight = this.syncHighlight.bind(this)
    document.addEventListener("turbo:frame-render", this.syncHighlight)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-render", this.syncHighlight)
  }

  syncHighlight(event) {
    const frame = event.target
    if (frame.id !== "retention_alert_detail") return

    // Prefer the frame's own src: history is updated after the render, so
    // reading location here can lag a click by a tick.
    const source = frame.getAttribute("src") || window.location.pathname
    const shown = new URL(source, window.location.origin).pathname

    this.rowTargets.forEach((row) => {
      const rowPath = new URL(row.href, window.location.origin).pathname
      row.classList.toggle("is-selected", rowPath === shown)
    })
  }
}
